import { render, staticRenderFns } from "./TechSpecification.vue?vue&type=template&id=0bce6306&scoped=true&"
import script from "./TechSpecification.vue?vue&type=script&lang=js&"
export * from "./TechSpecification.vue?vue&type=script&lang=js&"
import style0 from "./TechSpecification.vue?vue&type=style&index=0&id=0bce6306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce6306",
  null
  
)

export default component.exports